import { render, staticRenderFns } from "./elc.vue?vue&type=template&id=0d6a88ee&scoped=true"
import script from "./elc.vue?vue&type=script&lang=js"
export * from "./elc.vue?vue&type=script&lang=js"
import style0 from "./elc.vue?vue&type=style&index=0&id=0d6a88ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6a88ee",
  null
  
)

export default component.exports